var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLowerE(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 155,
    height: 152,
    viewBox: "0 0 155 152",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M154.3 74.8C154.3 35.8 119.5 0.699992 77.1996 0.699992C35.1996 0.699992 0.0996097 35.8 0.0996097 77.8C0.0996097 107.2 15.0996 131.8 40.8996 143.8C52.2996 149.2 64.8996 151.9 77.4996 151.9C99.0996 151.9 121.3 143.8 141.7 127L131.5 114.7C105.4 136.6 72.9996 141.4 47.4996 129.4C28.8996 120.4 17.7996 103.9 16.5996 85.9H154.6V74.8H154.3ZM16.5996 70C18.6996 41.2 44.7996 16.6 77.1996 16.6C109.9 16.6 135.7 41.2 138.1 70H16.5996Z",
    fill: "#FEC736"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLowerE);
export default __webpack_public_path__ + "static/media/LOWER_E.f6e7679c75f71eaab87f3faa5d88dcf8.svg";
export { ForwardRef as ReactComponent };